<template>
    <section id="router__section">
        <div
            class="error__alert__box"
            v-if="isErrorAlertVisible"
            :key="'main error alert'"
        >
            <div class="body">
                <p>
                    Сайт работает для тестирования - заказы не исполняются.
                    <button @click="toggleAlertVisible">Закрыть</button>
                </p>
            </div>
        </div>
        <the-header></the-header>
        <the-mobile-navbar></the-mobile-navbar>
        <router-view :key="$route.path"></router-view>
        <the-footer></the-footer>
        <notifications classes="custom-notification" />
    </section>
</template>

<script>
import TheFooter from "./TheFooter";
import TheHeader from "./TheHeader";
import TheMobileNavbar from "./TheMobileNavbar";

export default {
    components: {
        TheHeader,
        TheFooter,
        TheMobileNavbar
    },

    data() {
        return {
            isErrorAlertVisible: false
        };
    },

    methods: {
        toggleAlertVisible() {
            this.isErrorAlertVisible = false;
        },

        hideTemporaryBladeElement() {
            // hide unused div on blade file(it was created for SEO)
            const bladeElement = document.getElementsByClassName(
                "main__content__blade"
            );
            if (bladeElement.length > 0) bladeElement[0].style.display = "none";
        }
    },

    async mounted() {
        this.hideTemporaryBladeElement();

        // setTimeout(() => {
        //     this.toggleAlertVisible();
        // }, 2500);
    }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
@import "../../../sass/_mixins.scss";
@import "../../../sass/_animation";
@import "../../../../public/css/bootstrap.css";

#router__section {
    min-height: 100vh;
}

.error__alert__box {
    max-width: 1200px;
    margin: 0 auto;

    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    z-index: 100000000;
    padding: 0 50px;

    .body {
        margin: 0 auto;
        max-width: 1200px;

        padding: 0.75rem 1.25rem;
        border-radius: 5px;
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;

        display: flex;
        justify-content: center;
    }

    p {
        margin-bottom: 0;
    }

    button {
        color: #155724;
        padding: 0;

        border: none;
        outline: none;
        background-color: transparent;
        text-decoration: underline;

        &:hover {
            cursor: pointer;
        }
    }
}
</style>
